var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCriptografia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.001,
    height: 19.949,
    viewBox: "0 0 19.001 19.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.393,21.386h-.478V18.419a4.269,4.269,0,1,0-8.538,0v2.967H30.9A1.612,1.612,0,0,0,29.289,23v.312H24.973a.35.35,0,0,0,0,.7h4.315v.934H26.5a.35.35,0,0,0,0,.7h2.793v.934H24.973a.35.35,0,0,0,0,.7h4.315v.934H26.5a.35.35,0,0,0,0,.7h2.793v.934H24.973a.35.35,0,0,0,0,.7h4.315v.934H26.5a.35.35,0,0,0,0,.7h2.793v.31A1.612,1.612,0,0,0,30.9,34.1h9.494A1.612,1.612,0,0,0,42,32.489V23a1.612,1.612,0,0,0-1.61-1.61Zm-8.316-2.967a3.569,3.569,0,1,1,7.138,0v2.967h-.778V18.419a2.791,2.791,0,1,0-5.583,0v2.968h-.777Zm1.478,2.967V18.419a2.091,2.091,0,1,1,4.182,0v2.968Zm7.748,11.1a.911.911,0,0,1-.91.91H30.9a.911.911,0,0,1-.91-.91V30.545h1.738a.35.35,0,1,0,0-.7H29.989V27.277h1.738a.35.35,0,1,0,0-.7H29.989V24.008h1.738a.35.35,0,1,0,0-.7H29.989V23a.911.911,0,0,1,.91-.91h9.494a.911.911,0,0,1,.91.91Z",
    transform: "translate(-23.002 -14.15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.55,66.978a1.824,1.824,0,1,0-2.331,2.8v1.644a1.172,1.172,0,0,0,2.344,0V69.783a1.824,1.824,0,0,0-.013-2.805Zm-.533,2.341a.35.35,0,0,0-.155.291v1.817a.472.472,0,1,1-.944,0V69.609a.35.35,0,0,0-.155-.29,1.124,1.124,0,0,1,.4-2.034,1.216,1.216,0,0,1,.231-.022,1.108,1.108,0,0,1,.712.256,1.124,1.124,0,0,1-.087,1.8Z",
    transform: "translate(-59.748 -56.07)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.873,68.783h1.621a.35.35,0,1,0,0-.7H16.873a.35.35,0,1,0,0,.7Z",
    transform: "translate(-16.523 -57.291)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.873,85.117h1.621a.35.35,0,1,0,0-.7H16.873a.35.35,0,1,0,0,.7Z",
    transform: "translate(-16.523 -70.357)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.494,100.75H16.873a.35.35,0,1,0,0,.7h1.621a.35.35,0,1,0,0-.7Z",
    transform: "translate(-16.523 -83.421)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCriptografia);
export default __webpack_public_path__ + "static/media/ico-criptografia.3927998b925c9279752dbaa76750f4bf.svg";
export { ForwardRef as ReactComponent };